import StateData from '../../../../../assets/data/StateData'

// Limits the previous Export/Import/Domestic forms enforced before submitting
export const LIMITS = {
  contents: 70,
  docKg: 2,
  line1: 45,
  line1ExportReceiver: 35,
  photoBytes: 3 * 1024 * 1024,
}

export const PRESETS = [
  { key: 'envelope', name: 'Envelope', l: 35, wd: 27, h: 2 },
  { key: 'small', name: 'Small box', l: 30, wd: 20, h: 15 },
  { key: 'medium', name: 'Medium box', l: 40, wd: 30, h: 25 },
  { key: 'large', name: 'Large box', l: 60, wd: 40, h: 40 },
]

// `value` is what the backend stores as the export reason
export const PURPOSES = [
  { value: 'gift', label: 'Gift' },
  { value: 'commercial', label: 'Commercial' },
  { value: 'personal, not for resale', label: 'Personal, not for resale' },
  { value: 'sample', label: 'Sample' },
  { value: 'return for repair', label: 'Return for repair' },
  { value: 'return after repair', label: 'Return after repair' },
]

export const CURRENCIES = [
  { value: 'NGN', label: 'Naira (₦)' },
  { value: 'USD', label: 'US dollar ($)' },
  { value: 'GBP', label: 'Pound sterling (£)' },
  { value: 'EUR', label: 'Euro (€)' },
]

export const CUR_SYM: Record<string, string> = {
  NGN: '₦',
  USD: '$',
  GBP: '£',
  EUR: '€',
}

// Shown next to the options; the charged amounts come back from the price API
export const ADDON_PRICES = { bubble: 500, vacuum: 500, phyto: 2000 }

export const PROHIBITED = [
  'Cash, cheques, gold bullion, travellers cheques and activated credit cards',
  'Firearms, ammunition and explosives — including replicas',
  'Narcotics and any goods illegal in either country',
  'Counterfeit or pirated goods',
  'Endangered animals and plants, and their products (CITES Appendix 1)',
  'Pornographic material and, for some destinations, alcohol',
]

export const STATE_NAMES: string[] = StateData.map((s: any) => s.state.name)

export const lgasFor = (state: string): string[] =>
  (StateData.find((s: any) => s.state.name === state) as any)?.state.locals.map(
    (l: any) => l.name,
  ) || []
